import config from '../config';

/**
 * Opens the desktop ArtWeaver through the `eduart://` protocol handler
 * (components/student/computer-apps/edu-poc/CLIENT_SETUP.md). The launcher
 * prepares a blank JPEG; when the student saves and closes ArtWeaver it uploads
 * the picture to their gallery and submits it for coach review. This is the same
 * call FreeSketchMode makes for its Open ArtWeaver button.
 */
export function launchArtWeaver(studentId) {
  const params = new URLSearchParams({
    token: localStorage.getItem('token') || '',
    studentId,
    serverUrl: config.API_BASE_URL,
    t: String(Date.now()),
  });

  window.location.href = `eduart://open?${params.toString()}`;
}
